// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { AccountValue } from './account-value';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class Period extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  periodId!: number;
  adminId!: number;
  createdBy!: string;
  createdDate!: Date;
  description?: string;
  flags?: number;
  fromDate!: Date;
  toDate!: Date;
  ts!: string;
  updatedBy!: string;
  updatedDate!: Date;
  accountValues!: AccountValue[];
}

